import React, { useState } from "react";
import logo from "../../../Assets/jklogo.png";
import jsPDF from "jspdf";
import "jspdf-autotable";
import PdfPreview from '../../../Common/PDFPreview'
import PrintButton from "../../../Common/Buttons/PrintPDF";
import { ConvertNumberToWord } from "../../../Common/FormatFunctions/ConvertNumberToWord";
import { formatReadableAmount } from "../../../Common/FormatFunctions/FormatAmount";

const API_URL = process.env.REACT_APP_API;


const AgroPurchaseReport = ({ doc_no, Tran_Type, disabledFeild }) => {
    const companyCode = sessionStorage.getItem("Company_Code");
    const Year_Code = sessionStorage.getItem("Year_Code");
    const [invoiceData, setInvoiceData] = useState([]);
    const [pdfPreview, setPdfPreview] = useState(null);

    const fetchData = async () => {
        try {
            const response = await fetch(
                `${API_URL}/generating_AgroPurchase_report?Company_Code=${companyCode}&Year_Code=${Year_Code}&doc_no=${doc_no}&TranType=${Tran_Type}`
            );
            if (!response.ok) {
                throw new Error("Network response was not ok");
            }
            const data = await response.json();

            setInvoiceData(data.all_data);
            generatePdf(data.all_data);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const generatePdf = async (data) => {
        const pdf = new jsPDF({ orientation: "portrait" });
        const allData = data?.[0] || {};
        const logoImg = new Image();
        const other = ""; // define Other field

        logoImg.src = logo;
        logoImg.onload = () => {
            // === Header ===
            pdf.addImage(logoImg, "PNG", 5, 5, 30, 30);
            pdf.setFontSize(14);
            pdf.text(`${allData.Company_Name_E || ""}`, 40, 10);
            pdf.setFontSize(8);
            pdf.setFont("helvetica", "bold");
            pdf.text(`${allData.AL1 || ""}`, 40, 15);
            pdf.text(`${allData.AL2 || ""}`, 40, 20);
            pdf.text(`${allData.AL3 || ""}`, 40, 25);
            pdf.text(`${allData.AL4 || ""}`, 40, 30);
            pdf.text(`${allData.Other || ""}`, 40, 35);

            pdf.setFontSize(12);
            pdf.setLineWidth(0.3);
            pdf.line(10, 38, 200, 38);

            pdf.setFontSize(10);
            pdf.text("Farmer/URP Purchase", 90, 43);
            pdf.line(10, 45, 200, 45);

            // === Prepare Table Data ===
            const tableData = [
                ["Party Name", allData.PartyName || ""],
                ["Address", allData.Address_E || ""],
                ["Adhar No", allData.adhar_no || ""],
                ["PAN No", allData.CompanyPan || ""],
              //  ["Narration", allData.Narration || ""],
               
            ];

            const buyerData = [
                ["Bill No", allData.Doc_No || ""],
                ["Date Of Supply", allData.doc_dateConverted || ""],
                ["Katta Date", allData.doc_dateConverted || ""],
               
                ["Lorry No", allData.Truck_No || ""],
            ];

            const buyerData1 = [
                
                ["Item Name", allData.itemname || ""],
            ];

            // === LEFT TABLE ===
            pdf.autoTable({
                startY: 48,
                margin: { left: 10 },
                body: tableData,
                theme: "plain",
                styles: { cellPadding: 1, fontSize: 8, halign: "left", valign: "middle", overflow: "linebreak" },
                columnStyles: { 0: { cellWidth: 25, fontStyle: "bold" }, 1: { cellWidth: 65 } },
            });
            const leftEndY = pdf.lastAutoTable.finalY;

            // === RIGHT TABLE 1 ===
            pdf.autoTable({
                startY: 48,
                margin: { left: pdf.internal.pageSize.width / 2 + 5 },
                body: buyerData,
                theme: "plain",
                styles: { cellPadding: 1, fontSize: 8, halign: "left", valign: "middle", overflow: "linebreak" },
                columnStyles: { 0: { cellWidth: 30, fontStyle: "bold" }, 1: { cellWidth: 50 } },
            });
            const rightEndY = pdf.lastAutoTable.finalY;

            // === RIGHT TABLE 2 ===
            pdf.autoTable({
                startY: rightEndY + 2,
                margin: { left: pdf.internal.pageSize.width / 2 + 5 },
                body: buyerData1,
                theme: "plain",
                styles: { cellPadding: 1, fontSize: 8, halign: "left", valign: "middle", overflow: "linebreak" },
                columnStyles: { 0: { cellWidth: 30, fontStyle: "bold" }, 1: { cellWidth: 50 } },
            });
            const bottomY = Math.max(pdf.lastAutoTable?.finalY || 0, leftEndY || 0);
pdf.setLineWidth(0.2);
pdf.line(10, bottomY, 200, bottomY); // top border of summary box

// === layout constants ===
const leftX = 10;
const labelEndX = 40;           // left label/value divider
const middleX = 80;             // divider between left & right columns
const rightLabelEnd = 130;      // right label/value divider
const pageRight = 200;          // page right border

const leftLabelX = leftX + 5;
const leftValueX = labelEndX + 5;
const rightLabelX = middleX + 5;
const rightValueX = rightLabelEnd + 5;

// === data ===
const leftData = [
  ["Weight", allData.Quintal || ""],
  ["Kadta", allData.Kadta_In_Qty || ""],
 
  ["Other", formatReadableAmount(allData.OtherAmount || 0)],
  ["Net Weight", allData.Net_Wt || ""],
   ["Rate", allData?.Rate ? formatReadableAmount(allData.Rate) : "0"],
];

const rightData = [
  ["Account Number", allData.Bank_Ac_No || ""],
  ["Bank IFSC Code", allData.IFSC || ""],
  ["Mobile No", allData.Mobile_No || ""],
  ["Item Value", allData?.Taxable_Amount ? formatReadableAmount(allData.Taxable_Amount) : "0"],
  
  ["Hamali", formatReadableAmount(parseFloat(allData?.Hamali) || 0)],
  ["Advance", formatReadableAmount(parseFloat(allData?.Cash_Advance) || 0)],
  ["Other +/-", formatReadableAmount(parseFloat(allData?.Other) || 0)],
  
  ["Net Payable", allData?.Amount ? formatReadableAmount(allData.Amount) : "0"],
  ["RTGS/NEFT", allData.RTGS_NEFT || ""],
];

// === style and setup ===
pdf.setFontSize(8);
pdf.setFont("helvetica", "normal");
pdf.setLineWidth(0.1);

const rowHeight = 8;
let y = bottomY;
const startY = y;
const maxRows = Math.max(leftData.length, rightData.length);

for (let i = 0; i < maxRows; i++) {
  const leftLabel = leftData[i]?.[0] || "";
  const leftValue = leftData[i]?.[1]?.toString().trim() || "";
  const rightLabel = rightData[i]?.[0] || "";
  const rightValue = rightData[i]?.[1]?.toString().trim() || "";

  // skip completely empty rows
  if (!leftLabel && !leftValue && !rightLabel && !rightValue) continue;

  const textY = y + rowHeight / 2 + 2.5;

  // === print text ===
  if (leftLabel || leftValue) {
    pdf.text(leftLabel, leftLabelX, textY);
    pdf.text(leftValue, labelEndX + 35, textY, { align: "right" });
    pdf.setFont(undefined, "bold");
  }
  if (rightLabel || rightValue) {
    pdf.text(rightLabel, rightLabelX, textY);
    pdf.text(rightValue, rightLabelEnd + 65, textY, { align: "right" });
    pdf.setFont(undefined, "bold");
  }

  // === draw line conditions ===
  if (leftLabel || leftValue) {
    // full-width line if left side has data
    pdf.line(leftX, y + rowHeight, pageRight, y + rowHeight);
  } else if (rightLabel || rightValue) {
    // only right side line if left side blank
    pdf.line(middleX, y + rowHeight, pageRight, y + rowHeight);
  }

  y += rowHeight;
}

// === vertical borders ===
pdf.setLineWidth(0.2);
pdf.line(leftX, startY, leftX, y);                 // left border
pdf.line(labelEndX, startY, labelEndX, y);         // left divider
pdf.line(middleX, startY, middleX, y);             // center divider
pdf.line(rightLabelEnd, startY, rightLabelEnd, y); // right divider
pdf.line(pageRight, startY, pageRight, y);         // right border

// === bottom border ===
pdf.line(leftX, y, pageRight, y);

const rawAmount = parseFloat(allData.Amount || 0); 
const totalAmount = formatReadableAmount(rawAmount); 
const totalAmountWords = ConvertNumberToWord(rawAmount);


// === TOTAL AMOUNT ROW ===
pdf.setFontSize(9);
pdf.setFont("helvetica", "bold");

const totalLabel = "Amount in Words";
const totalValue = totalAmountWords;
//pdf.text(`Amount in Words: ${totalAmountWords}`, leftLabelX, y + 6);
const totalY = y + 10;

pdf.text(totalLabel, leftLabelX, totalY);
pdf.text(totalValue, pageRight - 40, totalY, { align: "right" });

pdf.line(leftX, totalY + 2, pageRight, totalY + 2);

y = totalY + 8;

// === Amount in Words ===
pdf.setFont("helvetica", "normal");
pdf.setFontSize(8);

//pdf.text(`Amount in Words: ${totalAmountWords}`, leftLabelX, y + 6);
 const pdfData = pdf.output("datauristring");
            setPdfPreview(pdfData);
        };
    };

    return (
        <div id="pdf-content">
            {pdfPreview && <PdfPreview pdfData={pdfPreview} apiData={invoiceData[0]} label={"AgroPurchase"} />}
            <PrintButton disabledFeild={disabledFeild} fetchData={fetchData} />
        </div>
    );
};

export default AgroPurchaseReport;